import { createSlice } from '@reduxjs/toolkit';

const ContractDetailsDataSlice = createSlice({
    name: 'ContractDetailsData',
    initialState: '',
    reducers: {
        setContractDetailsData: (state, action) => {
            return action.payload;
        },
        resetContractDetailsData: (state) => {
            return null;
        },
    },
});

export const { setContractDetailsData, resetContractDetailsData } = ContractDetailsDataSlice.actions;
export default ContractDetailsDataSlice.reducer;